import useTranslator from "../../../hooks/useTranslator";
import SkorProtectShield from "../../../assets/img/skor-protect-shield.png";
import Badge from "../Badge/Badge";
import "./SkorProtectBadge.css";

const SkorProtectBadge = () => {
  const { _t } = useTranslator();

  return (
    <Badge tone="lime">
      <img
        src={SkorProtectShield}
        alt=""
        className="ds-skor-protect-badge__shield"
      />
      {_t("skorProtectTitle")}
    </Badge>
  );
};

export default SkorProtectBadge;
